import moment from 'moment'

export const titles = [
  { value: '', text: 'Please Select' },
  { value: 'Mr.', text: 'Mr.' },
  { value: 'Ms.', text: 'Ms.' },
  { value: 'Mrs.', text: 'Mrs.' },
  { value: 'Miss', text: 'Miss' },
  { value: 'Mx.', text: 'Mx.' },
  { value: 'Dr.', text: 'Dr.' }
]

export const suffixes = [
  { value: '', text: 'Please Select' },
  { value: 'Jr.', text: 'Jr.' },
  { value: 'Sr.', text: 'Sr.' },
  { value: 'II', text: 'II' },
  { value: 'III', text: 'III' },
  { value: 'IV', text: 'IV' },
  { value: 'PhD', text: 'PhD' },
  { value: 'MD', text: 'MD' },
  { value: 'MA', text: 'MA' },
  { value: 'MSc', text: 'MSc' },
  { value: 'Esq', text: 'Esq' }
]

export const countries = [
  { value: '', text: 'Please Select' },
  { value: 'AF', text: 'Afghanistan' },
  { value: 'AX', text: 'Åland Islands' },
  { value: 'AL', text: 'Albania' },
  { value: 'DZ', text: 'Algeria' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AD', text: 'Andorra' },
  { value: 'AO', text: 'Angola' },
  { value: 'AI', text: 'Anguilla' },
  { value: 'AQ', text: 'Antarctica' },
  { value: 'AG', text: 'Antigua and Barbuda' },
  { value: 'AR', text: 'Argentina' },
  { value: 'AM', text: 'Armenia' },
  { value: 'AW', text: 'Aruba' },
  { value: 'AU', text: 'Australia' },
  { value: 'AT', text: 'Austria' },
  { value: 'AZ', text: 'Azerbaijan' },
  { value: 'BS', text: 'Bahamas' },
  { value: 'BH', text: 'Bahrain' },
  { value: 'BD', text: 'Bangladesh' },
  { value: 'BB', text: 'Barbados' },
  { value: 'BY', text: 'Belarus' },
  { value: 'BE', text: 'Belgium' },
  { value: 'BZ', text: 'Belize' },
  { value: 'BJ', text: 'Benin' },
  { value: 'BM', text: 'Bermuda' },
  { value: 'BT', text: 'Bhutan' },
  { value: 'BO', text: 'Bolivia, Plurinational State of' },
  { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', text: 'Bosnia and Herzegovina' },
  { value: 'BW', text: 'Botswana' },
  { value: 'BV', text: 'Bouvet Island' },
  { value: 'BR', text: 'Brazil' },
  { value: 'IO', text: 'British Indian Ocean Territory' },
  { value: 'BN', text: 'Brunei Darussalam' },
  { value: 'BG', text: 'Bulgaria' },
  { value: 'BF', text: 'Burkina Faso' },
  { value: 'BI', text: 'Burundi' },
  { value: 'KH', text: 'Cambodia' },
  { value: 'CM', text: 'Cameroon' },
  { value: 'CA', text: 'Canada' },
  { value: 'CV', text: 'Cape Verde' },
  { value: 'KY', text: 'Cayman Islands' },
  { value: 'CF', text: 'Central African Republic' },
  { value: 'TD', text: 'Chad' },
  { value: 'CL', text: 'Chile' },
  { value: 'CN', text: 'China' },
  { value: 'CX', text: 'Christmas Island' },
  { value: 'CC', text: 'Cocos (Keeling) Islands' },
  { value: 'CO', text: 'Colombia' },
  { value: 'KM', text: 'Comoros' },
  { value: 'CG', text: 'Congo' },
  { value: 'CD', text: 'Congo, the Democratic Republic of the' },
  { value: 'CK', text: 'Cook Islands' },
  { value: 'CR', text: 'Costa Rica' },
  { value: 'CI', text: 'Côte d\'Ivoire' },
  { value: 'HR', text: 'Croatia' },
  { value: 'CU', text: 'Cuba' },
  { value: 'CW', text: 'Curaçao' },
  { value: 'CY', text: 'Cyprus' },
  { value: 'CZ', text: 'Czech Republic' },
  { value: 'DK', text: 'Denmark' },
  { value: 'DJ', text: 'Djibouti' },
  { value: 'DM', text: 'Dominica' },
  { value: 'DO', text: 'Dominican Republic' },
  { value: 'EC', text: 'Ecuador' },
  { value: 'EG', text: 'Egypt' },
  { value: 'SV', text: 'El Salvador' },
  { value: 'GQ', text: 'Equatorial Guinea' },
  { value: 'ER', text: 'Eritrea' },
  { value: 'EE', text: 'Estonia' },
  { value: 'ET', text: 'Ethiopia' },
  { value: 'FK', text: 'Falkland Islands (Malvinas)' },
  { value: 'FO', text: 'Faroe Islands' },
  { value: 'FJ', text: 'Fiji' },
  { value: 'FI', text: 'Finland' },
  { value: 'FR', text: 'France' },
  { value: 'GF', text: 'French Guiana' },
  { value: 'PF', text: 'French Polynesia' },
  { value: 'TF', text: 'French Southern Territories' },
  { value: 'GA', text: 'Gabon' },
  { value: 'GM', text: 'Gambia' },
  { value: 'GE', text: 'Georgia' },
  { value: 'DE', text: 'Germany' },
  { value: 'GH', text: 'Ghana' },
  { value: 'GI', text: 'Gibraltar' },
  { value: 'GR', text: 'Greece' },
  { value: 'GL', text: 'Greenland' },
  { value: 'GD', text: 'Grenada' },
  { value: 'GP', text: 'Guadeloupe' },
  { value: 'GU', text: 'Guam' },
  { value: 'GT', text: 'Guatemala' },
  { value: 'GG', text: 'Guernsey' },
  { value: 'GN', text: 'Guinea' },
  { value: 'GW', text: 'Guinea-Bissau' },
  { value: 'GY', text: 'Guyana' },
  { value: 'HT', text: 'Haiti' },
  { value: 'HM', text: 'Heard Island and McDonald Islands' },
  { value: 'VA', text: 'Holy See (Vatican City State)' },
  { value: 'HN', text: 'Honduras' },
  { value: 'HK', text: 'Hong Kong' },
  { value: 'HU', text: 'Hungary' },
  { value: 'IS', text: 'Iceland' },
  { value: 'IN', text: 'India' },
  { value: 'ID', text: 'Indonesia' },
  { value: 'IR', text: 'Iran, Islamic Republic of' },
  { value: 'IQ', text: 'Iraq' },
  { value: 'IE', text: 'Ireland' },
  { value: 'IM', text: 'Isle of Man' },
  { value: 'IL', text: 'Israel' },
  { value: 'IT', text: 'Italy' },
  { value: 'JM', text: 'Jamaica' },
  { value: 'JP', text: 'Japan' },
  { value: 'JE', text: 'Jersey' },
  { value: 'JO', text: 'Jordan' },
  { value: 'KZ', text: 'Kazakhstan' },
  { value: 'KE', text: 'Kenya' },
  { value: 'KI', text: 'Kiribati' },
  { value: 'KP', text: 'Korea, Democratic People\'s Republic of' },
  { value: 'KR', text: 'Korea, Republic of' },
  { value: 'KW', text: 'Kuwait' },
  { value: 'KG', text: 'Kyrgyzstan' },
  { value: 'LA', text: 'Lao People\'s Democratic Republic' },
  { value: 'LV', text: 'Latvia' },
  { value: 'LB', text: 'Lebanon' },
  { value: 'LS', text: 'Lesotho' },
  { value: 'LR', text: 'Liberia' },
  { value: 'LY', text: 'Libya' },
  { value: 'LI', text: 'Liechtenstein' },
  { value: 'LT', text: 'Lithuania' },
  { value: 'LU', text: 'Luxembourg' },
  { value: 'MO', text: 'Macao' },
  { value: 'MK', text: 'Macedonia, the former Yugoslav Republic of' },
  { value: 'MG', text: 'Madagascar' },
  { value: 'MW', text: 'Malawi' },
  { value: 'MY', text: 'Malaysia' },
  { value: 'MV', text: 'Maldives' },
  { value: 'ML', text: 'Mali' },
  { value: 'MT', text: 'Malta' },
  { value: 'MH', text: 'Marshall Islands' },
  { value: 'MQ', text: 'Martinique' },
  { value: 'MR', text: 'Mauritania' },
  { value: 'MU', text: 'Mauritius' },
  { value: 'YT', text: 'Mayotte' },
  { value: 'MX', text: 'Mexico' },
  { value: 'FM', text: 'Micronesia, Federated States of' },
  { value: 'MD', text: 'Moldova, Republic of' },
  { value: 'MC', text: 'Monaco' },
  { value: 'MN', text: 'Mongolia' },
  { value: 'ME', text: 'Montenegro' },
  { value: 'MS', text: 'Montserrat' },
  { value: 'MA', text: 'Morocco' },
  { value: 'MZ', text: 'Mozambique' },
  { value: 'MM', text: 'Myanmar' },
  { value: 'NA', text: 'Namibia' },
  { value: 'NR', text: 'Nauru' },
  { value: 'NP', text: 'Nepal' },
  { value: 'NL', text: 'Netherlands' },
  { value: 'NC', text: 'New Caledonia' },
  { value: 'NZ', text: 'New Zealand' },
  { value: 'NI', text: 'Nicaragua' },
  { value: 'NE', text: 'Niger' },
  { value: 'NG', text: 'Nigeria' },
  { value: 'NU', text: 'Niue' },
  { value: 'NF', text: 'Norfolk Island' },
  { value: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NO', text: 'Norway' },
  { value: 'OM', text: 'Oman' },
  { value: 'PK', text: 'Pakistan' },
  { value: 'PW', text: 'Palau' },
  { value: 'PS', text: 'Palestinian Territory, Occupied' },
  { value: 'PA', text: 'Panama' },
  { value: 'PG', text: 'Papua New Guinea' },
  { value: 'PY', text: 'Paraguay' },
  { value: 'PE', text: 'Peru' },
  { value: 'PH', text: 'Philippines' },
  { value: 'PN', text: 'Pitcairn' },
  { value: 'PL', text: 'Poland' },
  { value: 'PT', text: 'Portugal' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'QA', text: 'Qatar' },
  { value: 'RE', text: 'Réunion' },
  { value: 'RO', text: 'Romania' },
  { value: 'RU', text: 'Russian Federation' },
  { value: 'RW', text: 'Rwanda' },
  { value: 'BL', text: 'Saint Barthélemy' },
  { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', text: 'Saint Kitts and Nevis' },
  { value: 'LC', text: 'Saint Lucia' },
  { value: 'MF', text: 'Saint Martin (French part)' },
  { value: 'PM', text: 'Saint Pierre and Miquelon' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'Samoa' },
  { value: 'SM', text: 'San Marino' },
  { value: 'ST', text: 'Sao Tome and Principe' },
  { value: 'SA', text: 'Saudi Arabia' },
  { value: 'SN', text: 'Senegal' },
  { value: 'RS', text: 'Serbia' },
  { value: 'SC', text: 'Seychelles' },
  { value: 'SL', text: 'Sierra Leone' },
  { value: 'SG', text: 'Singapore' },
  { value: 'SX', text: 'Sint Maarten (Dutch part)' },
  { value: 'SK', text: 'Slovakia' },
  { value: 'SI', text: 'Slovenia' },
  { value: 'SB', text: 'Solomon Islands' },
  { value: 'SO', text: 'Somalia' },
  { value: 'ZA', text: 'South Africa' },
  { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', text: 'South Sudan' },
  { value: 'ES', text: 'Spain' },
  { value: 'LK', text: 'Sri Lanka' },
  { value: 'SD', text: 'Sudan' },
  { value: 'SR', text: 'Suriname' },
  { value: 'SJ', text: 'Svalbard and Jan Mayen' },
  { value: 'SZ', text: 'Swaziland' },
  { value: 'SE', text: 'Sweden' },
  { value: 'CH', text: 'Switzerland' },
  { value: 'SY', text: 'Syrian Arab Republic' },
  { value: 'TW', text: 'Taiwan, Province of China' },
  { value: 'TJ', text: 'Tajikistan' },
  { value: 'TZ', text: 'Tanzania, United Republic of' },
  { value: 'TH', text: 'Thailand' },
  { value: 'TL', text: 'Timor-Leste' },
  { value: 'TG', text: 'Togo' },
  { value: 'TK', text: 'Tokelau' },
  { value: 'TO', text: 'Tonga' },
  { value: 'TT', text: 'Trinidad and Tobago' },
  { value: 'TN', text: 'Tunisia' },
  { value: 'TR', text: 'Turkey' },
  { value: 'TM', text: 'Turkmenistan' },
  { value: 'TC', text: 'Turks and Caicos Islands' },
  { value: 'TV', text: 'Tuvalu' },
  { value: 'UG', text: 'Uganda' },
  { value: 'UA', text: 'Ukraine' },
  { value: 'AE', text: 'United Arab Emirates' },
  { value: 'GB', text: 'United Kingdom' },
  { value: 'US', text: 'United States' },
  { value: 'UM', text: 'United States Minor Outlying Islands' },
  { value: 'UY', text: 'Uruguay' },
  { value: 'UZ', text: 'Uzbekistan' },
  { value: 'VU', text: 'Vanuatu' },
  { value: 'VE', text: 'Venezuela, Bolivarian Republic of' },
  { value: 'VN', text: 'Viet Nam' },
  { value: 'VG', text: 'Virgin Islands, British' },
  { value: 'VI', text: 'Virgin Islands, U.S.' },
  { value: 'WF', text: 'Wallis and Futuna' },
  { value: 'EH', text: 'Western Sahara' },
  { value: 'YE', text: 'Yemen' },
  { value: 'ZM', text: 'Zambia' },
  { value: 'ZW', text: 'Zimbabwe' }
]

export const genderList = [
  { text: 'He/him', value: 'he/him' },
  { text: 'She/her', value: 'she/her' },
  { text: 'They/them', value: 'they/them' },
  { text: 'Prefer not to say', value: 'unspecified' },
  { text: 'Other', value: 'other' }
]

export const underrepresentedList = [
  { value: 'eastAsian', text: 'East Asian (China, Japan, Korea, Mongolia, Taiwan, etc.)' },
  { value: 'southeastAsian', text: 'Southeast Asian (Thailand, Philippines, Indonesia, Singapore, Vietnam, etc.)' },
  { value: 'southAsian', text: 'South Asian (India, Pakistan, Bangladesh, Sri Lanka, etc.)' },
  { value: 'centralAsian', text: 'Central Asian (Kazakhstan, Kyrgyzstan, Tajikistan, Uzbekistan, Turkmenistan, Mongolia, Afghanistan, and northern Pakistan)' },
  { value: 'northAsian', text: 'North Asian (Asian part of Russia)' },
  { value: 'westAsian', text: 'West Asian (Middle Eastern, Arab, Iranian, Turkish, Kurdish, etc.)' },
  { value: 'white', text: 'White/Caucasian/North American/South American/European' },
  { value: 'african', text: 'African/African American/Afro-Caribbean/Afro-Latinx/Black' },
  { value: 'northAfrican', text: 'North African (Algeria, Egypt, Morocco, Tunisia, Libya, etc)' },
  { value: 'hispanicLatinx', text: 'Hispanic/Latinx (Mexico, Central America, the Caribbean including Puerto Rico and Haiti, South America including Brazil)' },
  { value: 'indigenous', text: 'First Peoples/Indigenous (Aboriginal, Alaska Native, Inuit, Native American, or other original peoples)' },
  { value: 'pacificIslander', text: 'Native Hawaiian/Pacific Islander (Maori, Samoan, and others)' },
  { value: 'unspecified', text: 'Prefer not to say' },
  { value: 'other', text: 'Other' }
]

export const languageList = [
  { value: 'Abkhazian', text: 'Abkhazian' },
  { value: 'Afar', text: 'Afar' },
  { value: 'Afrikaans', text: 'AfrikaansJr' },
  { value: 'Albanian', text: 'Albanian' },
  { value: 'American Sign Language', text: 'American Sign Language (ASL)' },
  { value: 'Amharic', text: 'Amharic' },
  { value: 'Arabic', text: 'Arabic' },
  { value: 'Aragonese', text: 'Aragonese' },
  { value: 'Armenian', text: 'Armenian' },
  { value: 'Assamese', text: 'Assamese' },
  { value: 'Aymara', text: 'Aymara' },
  { value: 'Azerbaijani', text: 'Azerbaijani' },
  { value: 'Bashkir', text: 'Bashkir' },
  { value: 'Basque', text: 'Basque' },
  { value: 'Bengali', text: 'Bengali' },
  { value: 'Bhutani', text: 'Bhutani' },
  { value: 'Bihari', text: 'Bihari' },
  { value: 'Bislama', text: 'Bislama' },
  { value: 'Breton', text: 'Breton' },
  { value: 'Bulgarian', text: 'Bulgarian' },
  { value: 'Burmese', text: 'Burmese' },
  { value: 'Byelorussian', text: 'Byelorussian' },
  { value: 'Cambodian', text: 'Cambodian' },
  { value: 'Catalan', text: 'Catalan' },
  { value: 'Cherokee', text: 'Cherokee' },
  { value: 'Chewa', text: 'Chewa' },
  { value: 'Chinese', text: 'Chinese' },
  { value: 'Corsican', text: 'Corsican' },
  { value: 'Croatian', text: 'Croatian' },
  { value: 'Czech', text: 'CzechJr' },
  { value: 'Danish', text: 'Danish' },
  { value: 'Divehi', text: 'Divehi' },
  { value: 'Dutch', text: 'Dutch' },
  { value: 'Edo', text: 'Edo' },
  { value: 'English', text: 'English' },
  { value: 'Esperanto', text: 'Esperanto' },
  { value: 'Estonian', text: 'Estonian' },
  { value: 'Faeroese', text: 'Faeroese' },
  { value: 'Farsi', text: 'Farsi' },
  { value: 'Fiji', text: 'Fiji' },
  { value: 'Finnish', text: 'Finnish' },
  { value: 'Flemish', text: 'Flemish' },
  { value: 'French', text: 'French' },
  { value: 'Frisian', text: 'Frisian' },
  { value: 'Fulfulde', text: 'Fulfulde' },
  { value: 'Galician', text: 'Galician' },
  { value: 'Gaelic', text: 'Gaelic' },
  { value: 'Georgian', text: 'Georgian' },
  { value: 'German', text: 'German' },
  { value: 'Greek', text: 'Greek' },
  { value: 'Greenlandic', text: 'Greenlandic' },
  { value: 'Guarani', text: 'Guarani' },
  { value: 'Gujarati', text: 'Gujarati' },
  { value: 'Haitian Creole', text: 'Haitian Creole' },
  { value: 'Hausa', text: 'Hausa' },
  { value: 'Hawaiian', text: 'Hawaiian' },
  { value: 'Hebrew', text: 'Hebrew' },
  { value: 'Hindi', text: 'Hindi' },
  { value: 'Hungarian', text: 'Hungarian' },
  { value: 'Ibibio', text: 'Ibibio' },
  { value: 'Icelandic', text: 'Icelandic' },
  { value: 'Ido', text: 'Ido' },
  { value: 'Igbo', text: 'Igbo' },
  { value: 'Indonesian', text: 'IndonesianJr' },
  { value: 'Interlingua', text: 'Interlingua' },
  { value: 'Interlingue', text: 'Interlingue' },
  { value: 'Inuktitut', text: 'Inuktitut' },
  { value: 'Inupiak', text: 'Inupiak' },
  { value: 'Irish', text: 'Irish' },
  { value: 'Italian', text: 'Italian' },
  { value: 'Japanese', text: 'Japanese' },
  { value: 'Kannada', text: 'Kannada' },
  { value: 'Kanuri', text: 'Kanuri' },
  { value: 'Kashmiri', text: 'Kashmiri' },
  { value: 'Kazakh', text: 'Kazakh' },
  { value: 'Kinyarwanda', text: 'Kinyarwanda' },
  { value: 'Kirghiz', text: 'Kirghiz' },
  { value: 'Kirundi', text: 'Kirundi' },
  { value: 'Konkani', text: 'Konkani' },
  { value: 'Korean', text: 'Korean' },
  { value: 'Kurdish', text: 'Kurdish' },
  { value: 'Laothian', text: 'Laothian' },
  { value: 'Latin', text: 'Latin' },
  { value: 'Latvian', text: 'Latvian' },
  { value: 'Limburgish', text: 'Limburgish' },
  { value: 'Lingala', text: 'Lingala' },
  { value: 'Lithuanian', text: 'Lithuanian' },
  { value: 'Macedonian', text: 'Macedonian' },
  { value: 'Malagasy', text: 'Malagasy' },
  { value: 'Malay', text: 'Malay' },
  { value: 'Malayalam', text: 'Malayalam' },
  { value: 'Maltese', text: 'Maltese' },
  { value: 'Maori', text: 'Maori' },
  { value: 'Marathi', text: 'Marathi' },
  { value: 'Moldavian', text: 'Moldavian' },
  { value: 'Mongolian', text: 'Mongolian' },
  { value: 'Nauru', text: 'Nauru' },
  { value: 'Nepali', text: 'Nepali' },
  { value: 'Norwegian', text: 'Norwegian' },
  { value: 'Occitan', text: 'Occitan' },
  { value: 'Oriya', text: 'Oriya' },
  { value: 'Oromo', text: 'Oromo' },
  { value: 'Papiamentu', text: 'Papiamentu' },
  { value: 'Pashto', text: 'Pashto' },
  { value: 'Polish', text: 'Polish' },
  { value: 'Portuguese', text: 'Portuguese' },
  { value: 'Punjabi', text: 'Punjabi' },
  { value: 'Quechua', text: 'Quechua' },
  { value: 'Rhaeto-Romance', text: 'Rhaeto-Romance' },
  { value: 'Romanian', text: 'Romanian' },
  { value: 'Russian', text: 'Russian' },
  { value: 'Sami', text: 'Sami' },
  { value: 'Samoan', text: 'Samoan' },
  { value: 'Sangro', text: 'Sangro' },
  { value: 'Sanskrit', text: 'Sanskrit' },
  { value: 'Serbian', text: 'Serbian' },
  { value: 'Sesotho', text: 'Sesotho' },
  { value: 'Setswana', text: 'Setswana' },
  { value: 'Shona', text: 'Shona' },
  { value: 'Sichuan Yi', text: 'Sichuan Yi' },
  { value: 'Sindhi', text: 'Sindhi' },
  { value: 'Sinhalese', text: 'Sinhalese' },
  { value: 'Siswati', text: 'Siswati' },
  { value: 'Slovak', text: 'Slovak' },
  { value: 'Slovenian', text: 'Slovenian' },
  { value: 'Somali', text: 'Somali' },
  { value: 'Spanish', text: 'Spanish' },
  { value: 'Sundanese', text: 'Sundanese' },
  { value: 'Swahili', text: 'Swahili' },
  { value: 'Swedish', text: 'Swedish' },
  { value: 'Syriac', text: 'Syriac' },
  { value: 'Tagalog', text: 'Tagalog' },
  { value: 'Tajik', text: 'Tajik' },
  { value: 'Tamazight', text: 'Tamazight' },
  { value: 'Tamil', text: 'Tamil' },
  { value: 'Tatar', text: 'Tatar' },
  { value: 'Telugu', text: 'Telugu' },
  { value: 'Thai', text: 'Thai' },
  { value: 'Tibetan', text: 'Tibetan' },
  { value: 'Tigrinya', text: 'TigrinyaJr' },
  { value: 'Tonga', text: 'Tonga' },
  { value: 'Tsonga', text: 'Tsonga' },
  { value: 'Turkish', text: 'Turkish' },
  { value: 'Turkmen', text: 'Turkmen' },
  { value: 'Twi', text: 'Twi' },
  { value: 'Uighur', text: 'Uighur' },
  { value: 'Ukrainian', text: 'Ukrainian' },
  { value: 'Urdu', text: 'Urdu' },
  { value: 'Uzbek', text: 'Uzbek' },
  { value: 'Venda', text: 'Venda' },
  { value: 'Vietnamese', text: 'Vietnamese' },
  { value: 'Volapük', text: 'Volapük' },
  { value: 'Wallon', text: 'Wallon' },
  { value: 'Welsh', text: 'Welsh' },
  { value: 'Wolof', text: 'Wolof' },
  { value: 'Xhosa', text: 'Xhosa' },
  { value: 'Yi', text: 'Yi' },
  { value: 'Yoruba', text: 'Yoruba' },
  { value: 'Zulu', text: 'Zulu' }
]

export const months = [
  { value: '', text: 'Select...' },
  { value: '1', text: 'January' },
  { value: '2', text: 'February' },
  { value: '3', text: 'March' },
  { value: '4', text: 'April' },
  { value: '5', text: 'May' },
  { value: '6', text: 'June' },
  { value: '7', text: 'July' },
  { value: '8', text: 'August' },
  { value: '9', text: 'September' },
  { value: '10', text: 'October' },
  { value: '11', text: 'November' },
  { value: '12', text: 'December' }
]

export const years = [
  { value: '', text: 'Select...' },
  moment().format('YYYY'),
  moment().add(1, 'y').format('YYYY'),
  moment().add(2, 'y').format('YYYY'),
  moment().add(3, 'y').format('YYYY'),
  moment().add(4, 'y').format('YYYY'),
  moment().add(5, 'y').format('YYYY'),
  moment().add(6, 'y').format('YYYY'),
  moment().add(7, 'y').format('YYYY')
]

export const svTypePreferences = [
  'In-person',
  'Virtual'
]

export const svTypePreferencesSecond = [
  'In-person',
  'Virtual',
  'None'
]

export const timeZones = [
  'Western North America',
  'South America and Eastern North America',
  'Europe and Western Africa',
  'Western/Central Asia and East Africa',
  'East Asia and Oceania'
]

export const previousSvYears = [
  '2025',
  '2024',
  '2023',
  '2022',
  '2021',
  '2020',
  '2019',
  '2018',
  '2017',
  '2016',
  '2015',
  '2014',
  '2013',
  '2012',
  '2011',
  '2010',
  '2009',
  '2008',
  '2007',
  '2006',
  '2005',
  '2004',
  '2003',
  '2002',
  '2001'
]

export const primaryTransportList = [
  { value: '', text: 'Please Select' },
  { value: 'plane', text: 'Airplane' },
  { value: 'car', text: 'Car' },
  { value: 'train', text: 'Train' },
  { value: 'other', text: 'Other' }
]

export const financialSituationOptions = [
  { value: 'internationalStudent', text: 'International Student or Seeking Residency' },
  { value: 'highCurrencyExchange', text: 'High Currency Exchange' },
  { value: 'working', text: 'Working Through School' },
  { value: 'lowIncome', text: 'Low Income' },
  { value: 'financiallyIndependent', text: 'Financially Independent' },
  { value: 'pellGrant', text: 'Pell Grant/Need based scholarship Recipient' },
  { value: 'disability', text: 'Disability' },
  { value: 'governmentAid', text: 'Receiving Government Aid' },
  { value: 'supportingFamily', text: 'Financially Supporting Family/Dependents' },
  { value: 'caregiver', text: 'Primary Caregiver is Ill or Disabled' }
]

export const roles = [
  { value: '1', text: 'Administrator' },
  { value: '2', text: 'Team Leader' },
  { value: '3', text: 'Student Volunteer' },
  { value: '4', text: 'Neutral' }
]

export const statuses = [
  { value: null, text: 'Submitted' },
  { value: '1', text: 'Offered' },
  { value: '2', text: 'Waitlist' },
  { value: '3', text: 'Rejected' },
  { value: '4', text: 'Team Leader' },
  { value: '5', text: 'Student Volunteer' },
  { value: '6', text: 'SV - Housing' },
  { value: '7', text: 'SV - Travel' },
  { value: '8', text: 'Declined' }
]

export const standard = [
  { value: '0', text: 'No' },
  { value: '1', text: 'Maybe' },
  { value: '2', text: 'Yes' }
]

export const essayScores = [
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5' }
]

export const conferenceLocations = [
  { value: '303 A-C', text: '303 A-C' },
  { value: '304 A-B', text: '304 A-B' },
  { value: 'Ballroom A', text: 'Ballroom A' },
  { value: 'Ballroom B', text: 'Ballroom B' },
  { value: 'Ballroom C', text: 'Ballroom C' },
  { value: 'Ballroom D', text: 'Ballroom D' },
  { value: 'Ballroom E', text: 'Ballroom E' },
  { value: 'Foyer', text: 'Foyer' },
  { value: 'Hall B', text: 'Hall B' },
  { value: 'Hall C/Experience Hall', text: 'Hall C/Experience Hall' }
]

export const amPm = [
  { value: 'AM', text: 'AM' },
  { value: 'PM', text: 'PM' }
]

export const shiftTimes = [
  { value: '07:00', text: '7:00 AM' },
  { value: '07:15', text: '7:15 AM' },
  { value: '07:30', text: '7:30 AM' },
  { value: '07:45', text: '7:45 AM' },
  { value: '08:00', text: '8:00 AM' },
  { value: '08:15', text: '8:15 AM' },
  { value: '08:30', text: '8:30 AM' },
  { value: '08:45', text: '8:45 AM' },
  { value: '09:00', text: '9:00 AM' },
  { value: '09:15', text: '9:15 AM' },
  { value: '09:30', text: '9:30 AM' },
  { value: '09:45', text: '9:45 AM' },
  { value: '10:00', text: '10:00 AM' },
  { value: '10:15', text: '10:15 AM' },
  { value: '10:30', text: '10:30 AM' },
  { value: '10:45', text: '10:45 AM' },
  { value: '11:00', text: '11:00 AM' },
  { value: '11:15', text: '11:15 AM' },
  { value: '11:30', text: '11:30 AM' },
  { value: '11:45', text: '11:45 AM' },
  { value: '12:00', text: '12:00 PM' },
  { value: '12:15', text: '12:15 PM' },
  { value: '12:30', text: '12:30 PM' },
  { value: '12:45', text: '12:45 PM' },
  { value: '13:00', text: '1:00 PM' },
  { value: '13:15', text: '1:15 PM' },
  { value: '13:30', text: '1:30 PM' },
  { value: '13:45', text: '1:45 PM' },
  { value: '14:00', text: '2:00 PM' },
  { value: '14:15', text: '2:15 PM' },
  { value: '14:30', text: '2:30 PM' },
  { value: '14:45', text: '2:45 PM' },
  { value: '15:00', text: '3:00 PM' },
  { value: '15:15', text: '3:15 PM' },
  { value: '15:30', text: '3:30 PM' },
  { value: '15:45', text: '3:45 PM' },
  { value: '16:00', text: '4:00 PM' },
  { value: '16:15', text: '4:15 PM' },
  { value: '16:30', text: '4:30 PM' },
  { value: '16:45', text: '4:45 PM' },
  { value: '17:00', text: '5:00 PM' },
  { value: '17:15', text: '5:15 PM' },
  { value: '17:30', text: '5:30 PM' },
  { value: '17:45', text: '5:45 PM' },
  { value: '18:00', text: '6:00 PM' },
  { value: '18:15', text: '6:15 PM' },
  { value: '18:30', text: '6:30 PM' },
  { value: '18:45', text: '6:45 PM' },
  { value: '19:00', text: '7:00 PM' },
  { value: '19:15', text: '7:15 PM' },
  { value: '19:30', text: '7:30 PM' },
  { value: '19:45', text: '7:45 PM' },
  { value: '20:00', text: '8:00 PM' }
]

export const shirtSizes = [
  { value: '', text: 'Select...' },
  { value: 'xs', text: 'XS (Extra Small)' },
  { value: 's', text: 'S (Small)' },
  { value: 'm', text: 'M (Medium)' },
  { value: 'l', text: 'L (Large)' },
  { value: 'xl', text: 'XL (Extra Large)' },
  { value: 'xxl', text: 'XXL (Double Extra Large)' },
  { value: 'xxxl', text: 'XXXL (Triple Extra Large)' }
]

export const diets = [
  { value: 'vegetarian', text: 'Vegetarian' },
  { value: 'pescatarian', text: 'Pescatarian' },
  { value: 'paleo', text: 'Paleo' },
  { value: 'kosher', text: 'Kosher' },
  { value: 'glutenFree', text: 'Gluten-free' },
  { value: 'dairyFree', text: 'Dairy-free' },
  { value: 'seafoodAllergy', text: 'Seafood allergy' },
  { value: 'nutAllergy', text: 'Nut allergy' },
  { value: 'other', text: 'Other' }
]

export const startTimes = [
  { value: '07:00', text: '7:00 AM' },
  { value: '07:30', text: '7:30 AM' },
  { value: '08:00', text: '8:00 AM' },
  { value: '08:30', text: '8:30 AM' },
  { value: '09:00', text: '9:00 AM' },
  { value: '09:30', text: '9:30 AM' },
  { value: '10:00', text: '10:00 AM' },
  { value: '10:30', text: '10:30 AM' },
  { value: '11:00', text: '11:00 AM' },
  { value: '11:30', text: '11:30 AM' },
  { value: '12:00', text: '12:00 PM' },
  { value: '12:30', text: '12:30 PM' },
  { value: '13:00', text: '1:00 PM' },
  { value: '13:30', text: '1:30 PM' },
  { value: '14:00', text: '2:00 PM' },
  { value: '14:30', text: '2:30 PM' },
  { value: '15:00', text: '3:00 PM' },
  { value: '15:30', text: '3:30 PM' },
  { value: '16:00', text: '4:00 PM' },
  { value: '16:30', text: '4:30 PM' },
  { value: '17:00', text: '5:00 PM' },
  { value: '17:30', text: '5:30 PM' },
  { value: '18:00', text: '6:00 PM' },
  { value: '18:30', text: '6:30 PM' },
  { value: '19:00', text: '7:00 PM' }
]

export const shifts = [
  { value: 'none', text: 'No Preference' },
  { value: 'artGallery', text: 'Art Gallery' },
  { value: 'etech', text: 'E-Tech' },
  { value: 'vrtheater', text: 'Virtual Reality' },
  { value: 'pavillion', text: 'Immersive Pavillion' },
  { value: 'labs', text: 'Labs' },
  { value: 'globalDiplomat', text: 'Global Diplomat' }
]

export const days = [
  { value: '2026-07-18', text: '18 July 2026' },
  { value: '2026-07-19', text: '19 July 2026' },
  { value: '2026-07-20', text: '20 July 2026' },
  { value: '2026-07-21', text: '21 July 2026' },
  { value: '2026-07-22', text: '22 July 2026' },
  { value: '2026-07-23', text: '23 July 2026' }
]

export const TLdays = [
  { value: '2026-07-17', text: '17 July 2026' },
  { value: '2026-07-18', text: '18 July 2026' },
  { value: '2026-07-19', text: '19 July 2026' },
  { value: '2026-07-20', text: '20 July 2026' },
  { value: '2026-07-21', text: '21 July 2026' },
  { value: '2026-07-22', text: '22 July 2026' },
  { value: '2026-07-23', text: '23 July 2026' }
]

export const referenceTypes = [
  { value: '', text: 'Select...' },
  { value: 'Professor/Teacher', text: 'Professor/Teacher' },
  { value: 'Academic Advisor', text: 'Academic Advisor' },
  { value: 'Professional Mentor', text: 'Professional Mentor' },
  { value: 'Work Supervisor', text: 'Work Supervisor' },
  { value: 'Coworker', text: 'Coworker' },
  { value: 'Other', text: 'Other' }
]



// WEBPACK FOOTER //
// ./src/util/SelectLists.js